// ============================================================
// Counter animation — .barrels__material-number
// ============================================================

(function () {
  function padTwo(n) {
    return n < 10 ? '0' + n : '' + n;
  }

  function animateCounter(el, target, duration) {
    var start = null;

    function step(timestamp) {
      if (!start) start = timestamp;
      var progress = Math.min((timestamp - start) / duration, 1);
      var eased = 1 - Math.pow(1 - progress, 3);
      var current = Math.round(target * eased);
      el.textContent = padTwo(current);
      if (progress < 1) requestAnimationFrame(step);
    }

    requestAnimationFrame(step);
  }

  function initCounters() {
    var numbers = document.querySelectorAll('.barrels__material-number');
    if (!numbers.length) return;

    numbers.forEach(function (el) {
      var val = parseInt(el.textContent, 10);
      if (!isNaN(val)) {
        el.dataset.target = val;
        el.textContent = '00';
      }
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.dataset.target, 10);
          if (!isNaN(target)) animateCounter(el, target, 1400);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    numbers.forEach(function (el) { observer.observe(el); });
  }

  // ============================================================
  // Nav Drawer
  // ============================================================

  function initDrawer() {
    var toggles = document.querySelectorAll('.menu-toggle');
    var drawer = document.getElementById('nav-drawer');
    var backdrop = document.getElementById('nav-drawer-backdrop');
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      backdrop.classList.add('is-open');
      toggles.forEach(function (btn) { btn.setAttribute('aria-expanded', 'true'); });
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      backdrop.classList.remove('is-open');
      toggles.forEach(function (btn) { btn.setAttribute('aria-expanded', 'false'); });
    }

    toggles.forEach(function (btn) {
      btn.addEventListener('click', function () {
        var isOpen = drawer.classList.contains('is-open');
        isOpen ? closeDrawer() : openDrawer();
      });
    });

    backdrop.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeDrawer();
    });
  }

  // ============================================================
  // Product quantity selector
  // ============================================================

  function initQuantitySelectors() {
    document.querySelectorAll('[data-quantity-selector]').forEach(function (selector) {
      var input = selector.querySelector('.product-quantity__input');
      var minus = selector.querySelector('[data-quantity-minus]');
      var plus = selector.querySelector('[data-quantity-plus]');
      if (!input || !minus || !plus) return;

      function minimum() {
        return parseInt(input.min, 10) || 1;
      }

      minus.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || minimum();
        input.value = Math.max(minimum(), value - 1);
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      plus.addEventListener('click', function () {
        var value = parseInt(input.value, 10) || minimum();
        input.value = value + 1;
        input.dispatchEvent(new Event('change', { bubbles: true }));
      });

      input.addEventListener('change', function () {
        var value = parseInt(input.value, 10);
        if (isNaN(value) || value < minimum()) input.value = minimum();
      });
    });
  }

  // ============================================================
  // AJAX cart notification
  // ============================================================

  function initCartNotification() {
    var notification = document.querySelector('[data-cart-notification]');
    var backdrop = document.querySelector('[data-cart-notification-backdrop]');
    if (!notification || !backdrop) return;

    var image = notification.querySelector('[data-cart-notification-image]');
    var title = notification.querySelector('[data-cart-notification-title]');
    var count = notification.querySelector('[data-cart-notification-count]');
    var error = notification.querySelector('[data-cart-notification-error]');
    var closeButtons = notification.querySelectorAll('[data-cart-notification-close]');
    var lastTrigger = null;

    function openNotification() {
      notification.hidden = false;
      backdrop.hidden = false;
      document.body.classList.add('cart-notification-open');
      requestAnimationFrame(function () {
        notification.classList.add('is-open');
        backdrop.classList.add('is-open');
      });
      var closeButton = notification.querySelector('.cart-notification__close');
      if (closeButton) closeButton.focus();
    }

    function closeNotification() {
      notification.classList.remove('is-open');
      backdrop.classList.remove('is-open');
      document.body.classList.remove('cart-notification-open');
      window.setTimeout(function () {
        notification.hidden = true;
        backdrop.hidden = true;
      }, 220);
      if (lastTrigger) lastTrigger.focus();
    }

    function updateCount(itemCount) {
      if (count) count.textContent = itemCount;
      document.querySelectorAll('.header-cart-count').forEach(function (element) {
        element.textContent = itemCount;
      });
      document.querySelectorAll('.header-cart-link').forEach(function (element) {
        element.setAttribute('aria-label', 'Cart with ' + itemCount + ' items');
      });
    }

    closeButtons.forEach(function (button) {
      button.addEventListener('click', closeNotification);
    });
    backdrop.addEventListener('click', closeNotification);
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && notification.classList.contains('is-open')) closeNotification();
    });

    document.querySelectorAll('form[action*="/cart/add"]').forEach(function (form) {
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        lastTrigger = event.submitter || form.querySelector('[type="submit"]');
        if (lastTrigger && lastTrigger.disabled) return;

        if (error) {
          error.hidden = true;
          error.textContent = '';
        }
        if (lastTrigger) lastTrigger.setAttribute('aria-busy', 'true');

        fetch(window.Shopify.routes.root + 'cart/add.js', {
          method: 'POST',
          headers: { Accept: 'application/json' },
          body: new FormData(form)
        })
          .then(function (response) {
            if (!response.ok) {
              return response.json().then(function (data) {
                throw new Error(data.description || 'This item could not be added to your cart.');
              });
            }
            return response.json();
          })
          .then(function (item) {
            if (title) title.textContent = item.product_title || item.title;
            if (image && item.featured_image && item.featured_image.url) {
              image.src = item.featured_image.url;
              image.alt = item.product_title || item.title;
            }
            return fetch(window.Shopify.routes.root + 'cart.js', {
              headers: { Accept: 'application/json' }
            });
          })
          .then(function (response) { return response.json(); })
          .then(function (cart) {
            updateCount(cart.item_count);
            openNotification();
          })
          .catch(function (exception) {
            if (error) {
              error.textContent = exception.message;
              error.hidden = false;
              openNotification();
            }
          })
          .finally(function () {
            if (lastTrigger) lastTrigger.removeAttribute('aria-busy');
          });
      });
    });
  }

  // ============================================================
  // Init
  // ============================================================

  function init() {
    initCounters();
    initDrawer();
    initQuantitySelectors();
    initCartNotification();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
